<template>
  <div class="complaint-details" v-loading="loading">
    <p class="title">权利投诉单</p>
    <el-row :gutter="10" type="flex" class="el-row-block first">
      <el-col :span="4" class="item">
        权利主张人的主体名称
      </el-col>
      <el-col :span="8" class="item content">
        <span>{{data.name}}</span>
      </el-col>
      <el-col :span="4" class="item">
        身份证明
      </el-col>
      <el-col :span="8" class="item content">
       <span>{{data.identity}}</span>
      </el-col>
    </el-row>
    <el-row :gutter="10" type="flex" class="el-row-block">
      <el-col :span="4" class="item">
        移动电话
      </el-col>
      <el-col :span="8" class="item content">
        <span>{{data.phone}}</span>
      </el-col>
      <el-col :span="4" class="item">
        联系微信/QQ/微信
      </el-col>
      <el-col :span="8" class="item content">
       <span></span>{{data.other}}</span>
      </el-col>
    </el-row>
    <el-row :gutter="10" type="flex" class="el-row-block">
      <el-col :span="3" class="item">
        权利主张人诉求
      </el-col>
      <el-col :span="17" class="item content">
        {{data.question}}
      </el-col>
    </el-row>
    <template v-for="(prove,index) in data.proves" >
      <el-row :gutter="10" type="flex" class="el-row-block last">
        <el-col :span="4" class="item">
          主张权利的图片截图
        </el-col>
        <el-col :span="8" class="item content">
          <img :src="prove.img_file" class="prove-img"/>
        </el-col>
        <el-col :span="4" class="item">
          主张权利图片截图的证明权益材料
        </el-col>
        <el-col :span="8" class="item content proof">
          <img :src="prove.proof_file" v-if="prove.proof_file" class="prove-img"/>
          <span v-if="prove.proof_text" class="proof-text">
            {{prove.proof_text}}
          </span>
        </el-col>
      </el-row>
    </template> 
  </div>
</template>

<script>
import axios from 'axios'

// axios.defaults.withCredentials = true
export default {
  name: 'complaintDetails',
  data() {
    return {
      loading: true,
      data: {
        name: '',
        identity: '',
        phone: '',
        other: '',
        question: '',
        proves: []
      }
    }
  },
  methods: {
    initLogin(){
      const id = this.$route.query.feedback_id
      
      if(this.$route.query.uacLoginToken){
        axios.post('/cfapi/v1/cms/uac/login', {'uacLoginToken': this.$route.query.uacLoginToken })
        .then(() => {
          this.initData(id)
          this.loading = false
        })
      }else {
        window.location.href= 'http://uac.dailyinnovation.biz?next=' + encodeURIComponent(window.location.href)
      }
    },
    initData(id) {
      axios.get(`/cfapi/v1/cms/feedback/${id}`)
      .then((res) => {
        const result = res.data.data
        this.data.name =  result.feedback_name
        this.data.identity =  result.feedback_id_number
        this.data.phone = result.feedback_phone
        this.data.other =  result.feedback_contact
        this.data.question = result.feedback_appeal
        this.data.proves = result.feedback_details
      })
    }
  },
  mounted() {
    this.initLogin()
  }
}
</script>

<style scoped>
.complaint-details{
  text-align: center;
  padding:2% 15%;
}
.title{
  font-size:30px;
  text-align: center;
}
.el-row-block{
  border:1px solid black;
  border-top:0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top:20px;
  padding-bottom: 20px;
}
.item{
  min-height:35px;
  font-weight: 700;
}
.content{
  font-weight: 500;
  color:rgb(146, 145, 145);
}
.first{
  border-top: 1px solid black;
}
.prove-img{
  width:150px;
  height:150px;
  object-fit: cover;
}
.proof{
  display: flex;
  justify-content: space-between;
}

.proof-text{
  margin-left:20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ComplaintDetails.vue